import {AdminMasterEmployeeResponse} from 'data/MasterEmployee/schemas/MasterEmployee.shema';
import {formatDateTime} from 'modules/Common';
import React, {useMemo} from 'react';
import {Button, Col, Container, Row, Spinner, Table} from 'react-bootstrap';
import {FaTimesCircle} from 'react-icons/fa';
import {useAdminCompanies} from '../../../../hooks';
import {MasterCompany} from '../../../../models/company/MasterCompany';

interface Props {
    userAdminMasterEmployee?: AdminMasterEmployeeResponse[];
    deleteUserAdmin: (user: AdminMasterEmployeeResponse) => void;
}

function WorkflowConfigAdminTable(props: Props) {
    const { userAdminMasterEmployee, deleteUserAdmin } = props;

    const { adminCompanies, isAllowedAllCompanies } = useAdminCompanies();
    const adminCompanyMap = useMemo(
        () =>
            adminCompanies
                ? new Map<string, MasterCompany>(
                      adminCompanies.map(adminCompany => [
                          adminCompany.sid,
                          adminCompany
                      ])
                  )
                : undefined,
        [adminCompanies]
    );

    const filteredAdmins = useMemo(
        () =>
            userAdminMasterEmployee?.filter(
                admin =>
                    isAllowedAllCompanies || adminCompanyMap?.has(admin.sid)
            ),
        [userAdminMasterEmployee, isAllowedAllCompanies, adminCompanyMap]
    );

    const handleDeleteUser = (user: AdminMasterEmployeeResponse) => {
        deleteUserAdmin(user);
    };

    return (
        <Container>
            <Row className="mt-3">
                <Col>
                    <Table
                        className="table-bordered align-middle"
                        size="sm"
                    >
                        <thead>
                            <tr
                                style={{ width: '100%' }}
                                className="table-active thead-light text-center"
                            >
                                <th style={{ width: '5%' }}></th>
                                <th style={{ width: '5%' }}>Company</th>
                                <th style={{ width: '10%' }}>Role Access</th>
                                <th style={{ width: '15%' }}>Employee ID</th>
                                <th style={{ width: '10%' }}>Employee Name</th>
                                <th style={{ width: '15%' }}>Create By</th>
                                <th style={{ width: '15%' }}>Create On</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!filteredAdmins ? (
                                <tr>
                                    <td
                                        colSpan={7}
                                        style={{
                                            background:
                                                'rgba(209, 250, 221, 1)',
                                            color: 'black',
                                            fontSize: '10pt',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <Spinner
                                            animation="border"
                                            size="sm"
                                        />
                                        &nbsp;&nbsp;Loading...
                                    </td>
                                </tr>
                            ) : (
                                filteredAdmins.map((value, index) => (
                                    <tr key={index}>
                                        <td className="text-center">
                                            <Button
                                                className="mx-1"
                                                variant="outline-danger"
                                                size="sm"
                                                onClick={() => handleDeleteUser(value)}
                                            >
                                                <FaTimesCircle />
                                            </Button>
                                        </td>
                                        <td className="text-center">
                                            {adminCompanyMap?.get(value.sid)
                                                ?.company_name ?? '*'}
                                        </td>
                                        <td className="text-center">
                                            {value.role_access}
                                        </td>
                                        <td>{value.id}</td>
                                        <td className="text-center">
                                            {value.empname}
                                        </td>
                                        <td className="text-center">
                                            {value.created_by}
                                        </td>
                                        <td className="text-center">
                                            {formatDateTime(value.created_on)}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container>
    );
}

export default WorkflowConfigAdminTable;
